import React from 'react';

import Details from './index';

export default (props) => {
  return <Details {...{ ...props, mode: 'DETAILS' }} />;
};
